













import { Component, Prop, Vue, Watch, Model } from 'vue-property-decorator';
import { Media, Lot, Auction } from '@/api';
import Cookies from 'js-cookie';

// @ts-ignore
import VueDropzone from 'vue2-dropzone';

@Component({
  components: { VueDropzone },
})
export default class extends Vue {
  dropzoneOptions: any = {
    url: Media.url(),
    maxFilesize: 15,
    // maxFiles: 1,
    resizeWidth: 1920,
    resizeHeight: 1920,
    resizeMethod: 'contain',
    addRemoveLinks: true,
    dictRemoveFile: '<i class="v-icon mdi mdi-delete" aria-label="Remove"></i>',
    paramName: 'media',
    params: {},
    headers: {
      'X-CSRFTOKEN': Cookies.get('csrftoken'),
      // Authorization: Media.generateAuthHeader(
      //   localStorage.getItem('jwt') || '',
      // ),
      'Cache-Control': undefined,
      Accept: 'application/vnd.api+json',
    },
    dictDefaultMessage: 'Click or drag a file here to upload',
    transformFile: (file: File, done: any): void => {
      if (
        (this.dropzoneOptions.resizeWidth ||
          this.dropzoneOptions.resizeHeight) &&
        file.type.match(/image.*/)
      ) {
        return this.resizeImage(
          file,
          this.dropzoneOptions.resizeWidth,
          this.dropzoneOptions.resizeHeight,
          this.dropzoneOptions.resizeMethod,
          done,
        );
      } else {
        return done(file);
      }
    },
  };

  resizeImage(
    file: any,
    width: number,
    height: number,
    resizeMethod: string,
    callback: (file: Blob) => void,
  ) {
    return this.createThumbnail(
      file,
      width,
      height,
      resizeMethod,
      true,
      (dataUrl: string | ArrayBuffer | null, canvas?: HTMLCanvasElement) => {
        if (canvas == null) {
          // The image has not been resized
          return callback(file);
        } else {
          let resizeMimeType = this.dropzoneOptions.resizeMimeType;

          if (resizeMimeType == null) {
            resizeMimeType = file.type;
          }

          const resizeQuality = this.dropzoneOptions.resizeQuality || 0.8;
          const resizedDataURL = canvas.toDataURL(
            resizeMimeType,
            resizeQuality,
          );

          // if (resizeMimeType === 'image/jpeg' || resizeMimeType === 'image/jpg') {
          //   // Now add the original EXIF information
          //   resizedDataURL = ExifRestore.restore(file.dataURL, resizedDataURL);
          // }

          return callback(this.dataURItoBlob(resizedDataURL));
        }
      },
    );
  }

  createThumbnail(
    file: any,
    width: number,
    height: number,
    resizeMethod: string,
    fixOrientation: boolean,
    callback: (
      dataUrl: string | ArrayBuffer | null,
      canvas?: HTMLCanvasElement,
    ) => void,
  ) {
    const fileReader = new FileReader();

    fileReader.onload = () => {
      file.dataURL = fileReader.result; // Don't bother creating a thumbnail for SVG images since they're vector

      if (file.type === 'image/svg+xml') {
        if (callback != null) {
          callback(fileReader.result);
        }

        return;
      }

      this.createThumbnailFromUrl(
        file,
        width,
        height,
        resizeMethod,
        fixOrientation,
        callback,
      );
    };

    fileReader.readAsDataURL(file);
  }

  createThumbnailFromUrl(
    file: any,
    width: number,
    height: number,
    resizeMethod: string,
    fixOrientation: boolean,
    callback: (dataUrl: string, canvas: HTMLCanvasElement) => void,
    crossOrigin?: string,
  ) {
    const img = document.createElement('img');

    if (crossOrigin) {
      img.crossOrigin = crossOrigin;
    }

    img.onload = () => {
      file.width = img.width;
      file.height = img.height;

      const resizeInfo = this.resize(file, width, height, resizeMethod);

      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      canvas.width = resizeInfo.trgWidth || 0;
      canvas.height = resizeInfo.trgHeight || 0;

      this.drawImageIOSFix(
        ctx,
        img,
        resizeInfo.srcX != null ? resizeInfo.srcX : 0,
        resizeInfo.srcY != null ? resizeInfo.srcY : 0,
        resizeInfo.srcWidth,
        resizeInfo.srcHeight,
        resizeInfo.trgX != null ? resizeInfo.trgX : 0,
        resizeInfo.trgY != null ? resizeInfo.trgY : 0,
        resizeInfo.trgWidth || 0,
        resizeInfo.trgHeight || 0,
      );
      const thumbnail = canvas.toDataURL('image/png');

      if (callback != null) {
        return callback(thumbnail, canvas);
      }
    };

    // if (callback != null) {
    //   img.onerror = callback;
    // }

    return (img.src = file.dataURL);
  }

  resize(file: any, width: number, height: number, resizeMethod: string) {
    const info: {
      srcX: number;
      srcY: number;
      srcWidth: number;
      srcHeight: number;
      trgWidth?: number;
      trgHeight?: number;
      trgX?: number;
      trgY?: number;
    } = {
      srcX: 0,
      srcY: 0,
      srcWidth: file.width,
      srcHeight: file.height,
    };
    const srcRatio = file.width / file.height; // Automatically calculate dimensions if not specified

    if (width == null && height == null) {
      width = info.srcWidth;
      height = info.srcHeight;
    } else if (width == null) {
      width = height * srcRatio;
    } else if (height == null) {
      height = width / srcRatio;
    } // Make sure images aren't upscaled

    width = Math.min(width, info.srcWidth);
    height = Math.min(height, info.srcHeight);
    const trgRatio = width / height;

    if (info.srcWidth > width || info.srcHeight > height) {
      // Image is bigger and needs rescaling
      if (resizeMethod === 'crop') {
        if (srcRatio > trgRatio) {
          info.srcHeight = file.height;
          info.srcWidth = info.srcHeight * trgRatio;
        } else {
          info.srcWidth = file.width;
          info.srcHeight = info.srcWidth / trgRatio;
        }
      } else if (resizeMethod === 'contain') {
        // Method 'contain'
        if (srcRatio > trgRatio) {
          height = width / srcRatio;
        } else {
          width = height * srcRatio;
        }
      } else {
        throw new Error('Unknown resizeMethod "'.concat(resizeMethod, '"'));
      }
    }

    info.srcX = (file.width - info.srcWidth) / 2;
    info.srcY = (file.height - info.srcHeight) / 2;
    info.trgWidth = width;
    info.trgHeight = height;
    return info;
  }

  drawImageIOSFix(
    ctx: CanvasRenderingContext2D | null,
    img: HTMLImageElement,
    sx: number,
    sy: number,
    sw: number,
    sh: number,
    dx: number,
    dy: number,
    dw: number,
    dh: number,
  ) {
    if (!ctx) {
      return;
    }
    const vertSquashRatio = this.detectVerticalSquash(img);
    return ctx.drawImage(img, sx, sy, sw, sh, dx, dy, dw, dh / vertSquashRatio);
  }

  detectVerticalSquash(img: HTMLImageElement) {
    const iw = img.naturalWidth;
    const ih = img.naturalHeight;
    const canvas = document.createElement('canvas');
    canvas.width = 1;
    canvas.height = ih;
    const ctx = canvas.getContext('2d');

    if (ctx) {
      ctx.drawImage(img, 0, 0);

      const getImageData = ctx.getImageData(1, 0, 1, ih);
      const data = getImageData.data; // search image edge pixel position in case it is squashed vertically.

      let sy = 0;
      let ey = ih;
      let py = ih;

      while (py > sy) {
        const alpha = data[(py - 1) * 4 + 3];

        if (alpha === 0) {
          ey = py;
        } else {
          sy = py;
        }

        /* tslint:disable-next-line:no-bitwise */
        py = (ey + sy) >> 1;
      }

      const ratio = py / ih;

      if (ratio === 0) {
        return 1;
      } else {
        return ratio;
      }
    } else {
      return 1;
    }
  }

  dataURItoBlob(dataURI: string) {
    // convert base64 to raw binary data held in a string
    // doesn't handle URLEncoded DataURIs - see SO answer #6850276 for code that does this
    const byteString = atob(dataURI.split(',')[1]); // separate out the mime component

    const mimeString = dataURI
      .split(',')[0]
      .split(':')[1]
      .split(';')[0]; // write the bytes of the string to an ArrayBuffer

    const ab = new ArrayBuffer(byteString.length);
    const ia = new Uint8Array(ab);

    for (
      let i = 0, end = byteString.length, asc = 0 <= end;
      asc ? i <= end : i >= end;
      asc ? i++ : i--
    ) {
      ia[i] = byteString.charCodeAt(i);
    } // write the ArrayBuffer to a blob

    return new Blob([ab], {
      type: mimeString,
    });
  } // Returns an array without the rejected item

  sendingEvent(file: any, xhr: any, formData: any) {
    let filename = '';
    const lastDotIndex = file.name.lastIndexOf('.');
    if (lastDotIndex === -1) {
      filename = file.name;
    } else {
      filename = file.name.substr(0, lastDotIndex);
    }
    formData.append('name', filename);
  }

  fileAdded() {
    // console.log('file added');
  }

  fileUploaded(file: any) {
    // console.log('file uploaded', file.xhr.response);

    try {
      const response = JSON.parse(file.xhr.response);
      const mediaId = response.data.id;
      this.$emit('media-uploaded', mediaId);

      setTimeout(() => {
        // @ts-ignore
        this.$refs.myVueDropzone.removeFile(file);
      }, 1000);
    } catch (e) {
      // error parsing response
    }
  }
}
